import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.locations-widget';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  const sanitizeEmbeddedMaps = (rawData) => rawData.replace(
    /("locationMap"\s*:\s*)(["']?)(<iframe[\s\S]*?<\/iframe>)(\2?)/gi,
    (match, prefix, quote, iframeHtml) => {
      const escaped = iframeHtml
        .replace(/\r?\n/g, ' ')
        .replace(/"/g, '\\"');
      return `${prefix}"${escaped}"`;
    },
  );

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const sanitizedData = sanitizeEmbeddedMaps(query.data);
      const { data } = dJSON.parse(sanitizedData);
      const actionsMarkup = /* html */ `
        <div class="location-item__actions" role="tablist">
          ${data.map((actionItem, actionIndex) => `
            <button
              type="button"
              class="btn-custom primary locations-actions__button${actionIndex === 0 ? ' is-active' : ''}"
              data-index="${actionIndex}"
              role="tab"
              aria-selected="${actionIndex === 0 ? 'true' : 'false'}"
            >
              ${actionItem.locationName}
            </button>
          `).join('')}
        </div>
      `;

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="location-item">
              <div class="location-item__left">
                <div class="location-item__header">
                  <p class="kicker">${item.kicker}</p>
                  <h3 class="title">${item.locationName}</h3>
                  <p class="description">${item.description}</p>
                </div>
                <div class="location-item__content">
                  <div class="location-item__info">
                    <div class="location-item__info__row">
                      <div class="location-item__info__row--left">
                        <h5>Call Us:</h5>
                      </div>
                      <div class="location-item__info__row--right">
                        <a href="tel:${item.phone}">${item.phone}</a>
                      </div>
                    </div>
                    <div class="location-item__info__row">
                      <div class="location-item__info__row--left">
                        <h5>Fax:</h5>
                      </div>
                      <div class="location-item__info__row--right">
                        <a href="fax:${item.fax}">${item.fax}</a>
                      </div>
                    </div>
                    <div class="location-item__info__row">
                      <div class="location-item__info__row--left">
                        <h5>Toll Free:</h5>
                      </div>
                      <div class="location-item__info__row--right">
                        <a href="tel:${item.tollFree}">${item.tollFree}</a>
                      </div>
                    </div>
                    <div class="location-item__info__row">
                      <div class="location-item__info__row--left">
                        <h5>Email Us:</h5>
                      </div>
                      <div class="location-item__info__row--right">
                        <a href="mailto:${item.email}">${item.email}</a>
                      </div>
                    </div>
                    <div class="location-item__info__row">
                      <div class="location-item__info__row--left">
                        <h5>Visit Us:</h5>
                      </div>
                      <div class="location-item__info__row--right">
                        <a href="${item.address}">${item.address}</a>
                      </div>
                    </div>
                  </div>
                  <div class="location-item__opening-hours">
                    <h5>Opening Hours</h5>
                    ${item.openingHours.map((hour) => `<p class="opening-hour"><span class="opening-hour__day">${hour.day}:</span> <span class="opening-hour__hours">${hour.hours}</span></p>`).join('')}
                    <p class="showroom-info">Showroom managed by appointment.</p>
                  </div>
                </div>
                ${actionsMarkup}
              </div>
              <div class="location-item__right">
                <div class="location-item__map">
                  ${item.locationMap ?? ''}
                </div>
                <div class="location-item__image">
                  <img src="${item.locationImage}" alt="${item.locationName}">
                </div>
              </div>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Slider settings
 */
(() => {
  document.querySelectorAll('.locations-widget .splide').forEach((item) => {
    const slider = new Splide(item, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: 0,
      pagination: false,
      arrows: false,
      autoplay: true,
      setInterval: 5000,
      breakpoints: {
        768: {
          pagination: true,
          arrows: false,
        },
      },
    });

    const moduleRoot = item.closest('.locations-widget');
    const actionButtons = moduleRoot
      ? Array.from(moduleRoot.querySelectorAll('.locations-actions__button'))
      : [];

    const setActiveAction = (activeIndex) => {
      actionButtons.forEach((button) => {
        const buttonIndex = Number(button.dataset.index);
        const isActive = buttonIndex === activeIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    if (moduleRoot && actionButtons.length) {
      moduleRoot.addEventListener('click', (event) => {
        const button = event.target.closest('.locations-actions__button');
        if (!button || !moduleRoot.contains(button)) return;

        const targetIndex = Number(button.dataset.index);
        if (Number.isNaN(targetIndex)) return;

        slider.go(targetIndex);
      });

      slider.on('mounted moved', () => {
        setActiveAction(slider.index);
      });
    }

    if (moduleRoot) {
      moduleRoot.addEventListener('click', (event) => {
        const image = event.target.closest('.location-item__image');
        if (!image || !moduleRoot.contains(image)) return;

        const rightColumn = image.closest('.location-item__right');
        if (!rightColumn) return;

        rightColumn.classList.toggle('is-expanded');
      });
    }

    slider.mount();
  });
})();
